import Vue from "vue";
import VueRouter from "vue-router";
import main from "../components/main.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "main",
    component: main
  },
  {
    path: "/main",
    name: "main+",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/main.vue")
  },
  {
    path: "/about",
    name: "about",

    component: () => import("../views/About.vue")
  },
  {
    path: "/sashpasscarengoil",
    name: "sashpasscarengoil",

    component: () => import("../components/sash/sashPassCarEngOil.vue")
  },
  {
    path: "/sashhavyduty",
    name: "sashhavyduty",

    component: () => import("../components/sash/sashHavyDuty.vue")
  },
  {
    path: "/sashauxilary",
    name: "sashauxilary",

    component: () => import("../components/sash/sashAuxilary.vue")
  },
  {
    path: "/sashagrocultural",
    name: "sashagrocultural",

    component: () => import("../components/sash/sashAgrocultural.vue")
  },
  {
    path: "/sashgreases",
    name: "sashgreases",

    component: () => import("../components/sash/sashGreases.vue")
  },
  {
    path: "/sashindustrial",
    name: "sashindustrial",

    component: () => import("../components/sash/sashIndustrial.vue")
  },
  {
    path: "/sashmarine",
    name: "sashmarine",

    component: () => import("../components/sash/sashMarine.vue")
  },
  {
    path: "/sashmotorcykle",
    name: "sashmotorcykle",

    component: () => import("../components/sash/sashMotorcykle.vue")
  },
  {
    path: "/sashtransmissions",
    name: "sashtransmissions",

    component: () => import("../components/sash/sashTransmissions.vue")
  },
  {
    path: "/sash",
    name: "sash",

    component: () => import("../components/sash.vue")
  },
  {
    path: "/status",
    name: "status",

    component: () => import("../components/sash/sashPassenger/status.vue")
  },
  {
    path: "/flagship",
    name: "flagship",

    component: () => import("../components/sash/sashPassenger/flagship.vue")
  },
  {
    path: "/galactic",
    name: "galactic",

    component: () => import("../components/sash/havyDuty/galactic.vue")
  },
  {
    path: "/master",
    name: "master",

    component: () => import("../components/sash/havyDuty/master.vue")
  },
  {
    path: "/endurance",
    name: "endurance",

    component: () => import("../components/sash/transsmission/endurance.vue")
  },
  {
    path: "/hidrol",
    name: "hidrol",

    component: () => import("../components/sash/industrial/hidrol.vue")
  },
  {
    path: "/export",
    name: "export",

    component: () => import("../components/sash/havyDuty/export.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
